import { render, staticRenderFns } from "./ProjectLists.vue?vue&type=template&id=5252045a"
import script from "./ProjectLists.vue?vue&type=script&lang=js"
export * from "./ProjectLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports